import logger from "../../lib/logger";

const tryGetJson = input => {
  let output;
  try {
    output = JSON.parse(input);
  } catch {
    logger.warn(`Invalid JSON found in markup: "${input}"`);
  }

  return output || {};
};

export default tryGetJson;
